// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__JLvnN","col":"Table_col__XOrAG","fulfillmentStatus":"Table_fulfillmentStatus__3xbQv","emailCol":"Table_emailCol__1sRZ7"};